"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function view() {
    var _this = this;
    return {
        state: {
            hasBannerImg: false
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                _this.view.state.hasBannerImg = (nextProps.backgroundImage) ? true : false;
                _this.forceRender();
                resolve();
            });
        },
        mounted: function () {
        },
        unmount: function () {
        },
        events: {
            onApplyClick: this.props.onApplyClick,
            onSaveClick: this.props.onSaveClick,
            onShareClick: this.props.onShareClick,
            setContentHeight: this.props.setContentHeight
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/4d5b8a78b9bd1a6f/src/.tmp/JobDetailsBanner/View.js
// module id = 785
// module chunks = 0